import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import FileIcon, { defaultStyles } from 'react-file-icon';

// Local
import AddAsset2 from './AddAsset2';
import { fetchAssets } from '../modules';

// const assets = [
//   {
//     id: '293r76!(DG@N*1d7G!',
//     name: 'new_smiles_background.jpg',
//     ext: 'jpg',
//   },
//   {
//     id: '9@YD(@8hd9!',
//     name: 'orange_button.png',
//     ext: 'png',
//   },
//   {
//     id: '9@wefpziJ$<OQFCYD(@8hd9!',
//     name: 'main_video.mpeg',
//     ext: 'mpeg',
//   },
// ];

export class Assets extends PureComponent {
  state = {
    addIsOpen: false,
    sel: '9@YD(@8hd9!',
  };

  renderRow = row => {
    const isSel = this.state.sel === row._id;
    return (
      <div
        className={classnames(
          'text-sm pl-2 pr-2 pt-1 pb-1 flex justify-between cursor-pointer',
          {
            'bg-green text-white': isSel,
          },
          {
            'text-green hover:bg-grey hover:text-white': !isSel,
          }
        )}
        key={row._id}
      >
        {/* <div>
          <FileIcon
            extension={row.ext}
            size={18}
            labelUppercase
            {...defaultStyles[row.ext]}
          />
        </div> */}
        <div className="flex flex-grow justify-between pl-1">
          <div>{row.name}</div>
          <div>x</div>
        </div>
      </div>
    );
  };

  handleAddDialogOpen = () => {
    this.setState({ addIsOpen: true });
  };

  handleAddDialogClose = () => {
    this.setState({ addIsOpen: false });
  };

  handleAssetAdded = asset => {
    console.log('ASSET_ADDED', asset);
  };

  componentDidMount() {
    this.props.fetchAssets(this.props.match.params.id);
  }

  render() {
    const { assets } = this.props;
    // console.log('ASSETS', assets);
    return (
      <div className="p-4">
        <div className="flex justify-between mb-2">
          <div className="text-sm font-bold">Assets</div>
          <div
            className="text-sm font-bold appearance-none cursor-pointer text-green hover:text-green-darker"
            onClick={this.handleAddDialogOpen}
          >
            +ADD
          </div>
        </div>
        <div>{assets.map(row => this.renderRow(row))}</div>
        <AddAsset2
          isOpen={this.state.addIsOpen}
          onClose={this.handleAddDialogClose}
          onAssetAdded={this.handleAssetAdded}
        />
      </div>
    );
  }
}

Assets.propTypes = {
  handleAddAsset: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    assets: state.mam2.assets,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchAssets: campaignId => dispatch(fetchAssets(campaignId)),
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(Assets);
